module.exports = __webpack_public_path__ + "a6d7cb1c389cd7727e0b9fb85060da24.svg";